module.exports = __webpack_public_path__ + "static/img/bg.8459cbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/medicine/bg.png
// module id = RQzv
// module chunks = 1